import TheHeader from './TheHeader'

export default TheHeader
